import {z} from 'zod';

import {reportFiltersSchema} from './ReportFiltersSchema';

const vehicleServiceTimeByMonthSchema = z.object({
  month: z.string(),
  caseCount: z.number(),
  totalDwellHours: z.number(),
  averageVehicleServiceTime: z.number(),
});

export type VehicleServiceTimeByMonth = z.infer<typeof vehicleServiceTimeByMonthSchema>;

const vehicleServiceTimeSummarySchema = vehicleServiceTimeByMonthSchema.omit({month: true});

export type VehicleServiceTimeSummary = z.infer<typeof vehicleServiceTimeSummarySchema>;

export const vehicleServiceTimeByMonthResponseSchema = z.object({
  data: z.array(vehicleServiceTimeByMonthSchema),
  summary: vehicleServiceTimeSummarySchema,
  filters: reportFiltersSchema,
});

export type VehicleServiceTimeByMonthResponse = z.infer<
  typeof vehicleServiceTimeByMonthResponseSchema
>;
